/* eslint-disable sort-keys-fix/sort-keys-fix */
import type { CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/kollektivlivmoder/"

const kollektivlivmoderCommunityStyles: CommunityData = {
  code: "kollektivlivmoder",
  name: "Kollektiv Livmoder",
  inviteCode: "kollektivlivmoder",
  thumbnail: "",
  favicon: "",
  url: "/c/liv-777",
  defaultCurrency: "SEK",
  socials: {},
  styles: {
    global: {
      counterColor: "#FF8DD4",
      alternativeLogo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[160px]",
      },
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[180px]",
      },
      modalWindow: {
        container: "rounded-[16px]",
        title: "font-['NeueHaasDisplayRoman'] text-[15px] text-[#000] tracking-[0.15px]",
        subtitle: "font-['NeueHaasDisplayRoman'] text-[15px] text-[#000] tracking-[0.15px]",
      },
      bgColor: "#6F8DB2",
      asideBg: "#FF8DD4",
      asideStyles: "border-r border-[#000000]",
      contentBg: "#FF8DD4",
      contentBoxShadow: "rounded-[16px] bg-[#FF8DD4]",
      nonMemberBg: `${S3_PREFIX}web-bg.mp4?type=video`,
      bgDesktop: `${S3_PREFIX}web-bg.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-bg.mp4?type=video`,
      mainFont: "font-['NeueHaasDisplayRoman']",
      primaryButton:
        "bg-[#000] text-[#FFF] font-['AnzeigenGrotesk'] !text-[26px] !px-[24px] !h-[58px] rounded-[12px] uppercase !tracking-[0.04em] !leading-[1]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "",
      separator: "",
      item: "font-['AnzeigenGrotesk'] text-[26px] text-[#000] uppercase opacity-50 text-center sm:!-ml-2",
      itemSelected: "!opacity-100",
    },
    communityLanding: {
      container: "!p-0 !m-0 border border-[#000000] rounded-[16px]",
      titles: "font-['AnzeigenGrotesk'] text-[40px] text-[#000] uppercase tracking-[0.8px]",
      emptyOrLoadingState: "!mx-4 sm:!mx-8 font-['NeueHaasDisplayRoman'] text-[15px] text-[#000]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle: "pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-full overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover rounded-[16px]",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-[16px]",
          content: "flex flex-col py-4 bg-[#FF8DDE]",
          title:
            "font-['AnzeigenGrotesk'] text-[26px] leading-[1] text-[#000] tracking-[0.52px] uppercase",
          subtitle: "font-['NeueHaasDisplayRoman'] text-[15px] text-[#000] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle: "pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden",
          mediaContainer:
            "w-full sm:!w-[228px] sm:!h-[128px] sm:flex-shrink-0 relative !rounded-[16px] overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-[#FF8DDE]",
          title: "font-['AnzeigenGrotesk'] text-[20px] uppercase leading-[1] tracking-[0.4px]",
          subtitle: "font-['NeueHaasDisplayRoman'] !text-[15px] !leading-[1] mt-2",
          location: "font-['NeueHaasDisplayRoman'] !text-[15px] !leading-[1] mt-2",
          date: "font-['NeueHaasDisplayRoman'] !text-[15px] !leading-[1] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "font-['AnzeigenGrotesk'] text-[28px] uppercase !font-normal tracking-[0.04em]",
        text: "font-['NeueHaasDisplayRoman'] text-[16px] leading-[1.2]",
        customShopImage: "https://media.werz.at/community-assets/kollektivlivmoder/web-shop.png",
        customShopImageStyle: "!rounded-[16px] !border-0 bg-gray-400",
        sectionTitle: "!mb-4 !sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col border border-[#000000] rounded-[16px]",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-[8px] !border-0",
        title:
          "font-['AnzeigenGrotesk'] text-[40px] tracking-[0.8px] leading-[1] uppercase !font-normal",
        subtitle:
          "font-['NeueHaasDisplayRoman'] text-[15px] mb-4 leading-[1.2] tracking-[0.01em] !normal-case",
        button: "!w-fit mb-4 sm:mb-0 rounded-[8px]",
        questions: "font-['NeueHaasDisplayRoman'] text-[12px]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "font-['AnzeigenGrotesk'] text-[40px] tracking-[0.8px] leading-[1] uppercase !font-normal",
        text: "font-['NeueHaasDisplayRoman'] text-[15px] mb-4 leading-[1.2] tracking-[0.01em] w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "font-['AnzeigenGrotesk'] text-[40px] tracking-[0.8px] leading-[1] uppercase !font-normal",
        text: "font-['NeueHaasDisplayRoman'] text-[15px] mb-4 leading-[1.2] tracking-[0.01em] max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden rounded-[8px] border border-[#000000]",
        mapPinColor: "",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "font-['AnzeigenGrotesk'] text-[40px] tracking-[0.8px] leading-[1] uppercase !font-normal",
        text: "font-['NeueHaasDisplayRoman'] !text-[15px]",
      },
      tickets: {
        header: "font-['AnzeigenGrotesk'] text-[26px] tracking-[0.04em] uppercase font-normal",
        outerContainer: "flex flex-col sm:p-8 p-4",
        innerContainer: "flex flex-col mt-4 rounded-[8px] overflow-hidden",
        ticket: {
          container: "flex flex-row justify-between gap-4 leading-auto tracking-[0.04em]",
          media: "!hidden",
          name: "font-['AnzeigenGrotesk'] text-[20px] tracking-[0.04em] uppercase",
          description: "font-['NeueHaasDisplayRoman'] text-[15px] leading-[1.2] tracking-[0.01em]",
          price: "font-['AnzeigenGrotesk'] text-[20px] tracking-[0.04em] uppercase",
          quantity: "font-['NeueHaasDisplayRoman'] text-[15px] leading-[1.2] tracking-[0.01em]",
          status: "font-['AnzeigenGrotesk'] text-[20px] tracking-[0.04em] uppercase",
          counterContainer:
            "bg-[#FFB4E9] !w-fit font-['NeueHaasDisplayRoman'] text-[14px] rounded-[8px] border border-[#000000]",
          button:
            "font-['NeueHaasDisplayRoman'] text-[14px] py-2 px-3 bg-[#FFB4E9] !w-fit rounded-[8px] border border-[#000000]",
          plusMinusColor: "#000000",
          descriptionCutoff: 27,
        },
      },
    },
  },
}

export default kollektivlivmoderCommunityStyles
